const getEnums = context => context.$store.getters.getEnums;

const orderStatus = (context, value) => {
  const { OrderStatusEnum } = getEnums(context);

  let aux;
  let result;

  for (const key in OrderStatusEnum) {
    if (OrderStatusEnum[key] === value) aux = key;
  }

  switch (aux) {
    case "PendingApproval":
      result = "Pendente";
      break;
    case "Approved":
      result = "Em Preparo";
      break;
    case "OutForDelivery":
      result = "Despachado";
      break;
    case "Delivered":
      result = "Entregue";
      break;
    case "Cancelled":
      result = "Cancelado";
      break;
    case "Refused":
      result = "Recusado";
      break;
    case "Refunded":
      result = "Reembolsado";
      break;
    case "AtEstablishment":
      result = "No estabelecimento";
      break;
    case "WaitingForFinish":
      result = "Esperando garçom";
      break;
    case "Finished":
      result = "Finalizado";
      break;
    case "WaitingForDelivery":
      result = "Aguardando entrega";
      break;
    case "WaitingForWaiter":
      result = "Aguardando garçom";
      break;
    default:
      result = "ERRO";
  }

  return result;
};

const locationType = (context, value) => {
  const { LocationTypes } = getEnums(context);

  let aux;
  let result;

  for (const key in LocationTypes) {
    if (LocationTypes[key] === value) aux = key;
  }

  switch (aux) {
    case "Delivery":
      result = "Delivery";
      break;
    case "TakeAway":
      result = "Retirada";
      break;
    case "Establishment":
      result = "Consumo local";
      break;
    case "Totem":
      result = "Totem";
      break;
    default:
      result = "ERRO";
  }

  return result;
};

const couponType = (context, value) => {
  const { DiscountTypes } = getEnums(context);

  return value === DiscountTypes.Percentage;
};

export { orderStatus, couponType, locationType };
